/**
 * MAP (in-file navigation graph — keep in sync with code):
 *   role:      pure util — «this custom field has nothing to show» (THE definition: the value renderer prints «—»
 *              for it, the UI nuova lists hide it behind «Mostra campi vuoti»)
 *   exports:   isCustomFieldEmpty(customField) → boolean
 *   used by:   components/custom-field-value.js (isEmpty getter), lib/custom-field-layout.js
 *   tests:     tests/unit/lib/custom-field-empty-test.js
 *   gotchas:   (1) checkbox (always yes / no), table and calculated fields are never empty. (2) Numeric types read
 *              number_value: 0 is a value, not empty. (3) Other types read value; blank / whitespace-only is empty.
 */
const NEVER_EMPTY = ['checkbox', 'table', 'calculated'];
const NUMERIC = ['currency', 'number', 'range'];
function isCustomFieldEmpty(customField) {
  const type = customField?.organization_custom_field?.data_type;
  if (NEVER_EMPTY.includes(type)) return false;
  if (NUMERIC.includes(type)) {
    const n = customField?.number_value;
    return n === null || n === undefined || n === '';
  }
  const v = customField?.value;
  return v === null || v === undefined || String(v).trim() === '';
}

export { isCustomFieldEmpty as default, isCustomFieldEmpty };
//# sourceMappingURL=custom-field-empty.js.map
